import { ReactNode } from 'react';
export type SessionContextValue = {
  session: Session;
  updateSession: (session: Session) => void;
};

export interface Actor {
  sub?: string;
  givenName?: string;
  familyName?: string;
  expiryTime?: string;
}
export interface AccountData {
  accountNumber?: number;
  profileRole?: string;
  accountName?: string;
  accountStatus?: string;
  accountCountry?: string;
}
export interface Session {
  id?: string;
  type?: string;
  userName?: string;
  partyId?: string;
  aboNum?: string;
  pinNUm?: string;
  warehouseId?: string;
  act?: Actor;
  email?: string;
  lastName?: string;
  currentAward?: string;
  highestAward?: string;
  accountExpirationDate?: string;
  /**
   * @deprecated - Use multiAccount instead
   */
  accounts?: AccountData[];
  uplineSponsorAccount?: string;
  renewalStatus?: string;
  renewalLifecycle?: string;
  currentAwardLevel?: string;
  primaryProfile?: boolean;
  accountCountry?: string;
  currentCountry?: string;
  multiAccount?: boolean;
}
export interface SessionProviderProps {
  children: ReactNode;
  session?: Session | null;
}

export interface SessionHook {
  session: Session;
  isAnonymous: () => boolean;
  isRegistered: () => boolean;
  isABO: () => boolean;
  isMember: () => boolean;
  isEmployee: () => boolean;
  isActor: () => boolean;
}
export enum UserType {
  ANONYMOUS = 'Anonymous',
  ABO = 'BUSINESS_OWNER',
  REGISTERED = 'CUSTOMER',
  MEMBER = 'MEMBER',
  EMPLOYEE = 'EMPLOYEE',
}
export enum AccountType {
  Employee = 'EMPLOYEE',
  MemberPlus = 'MEMBER_PLUS',
  Member = 'MEMBER',
  Customer = 'CUSTOMER',
  BusinessOwner = 'BUSINESS_OWNER',
}
